import { render, staticRenderFns } from "./websideworker.vue?vue&type=template&id=1c771e96&scoped=true"
import script from "./websideworker.vue?vue&type=script&lang=js"
export * from "./websideworker.vue?vue&type=script&lang=js"
import style0 from "./websideworker.vue?vue&type=style&index=0&id=1c771e96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c771e96",
  null
  
)

export default component.exports